// Initialize scripts after component mount
export const initScripts = () => {
  // Initialize any necessary scripts here
  console.log('Initializing scripts...');
  
  // Initialize navbar scroll behavior
  initNavbarScroll();
  
  // Add any initialization code for third-party libraries here
};

// Initialize navbar scroll behavior
const initNavbarScroll = () => {
  // Set initial state for mini navbar elements
  const miniNavbarElements = document.querySelectorAll(".navbar_mini_wrap > *");
  miniNavbarElements.forEach(el => {
    el.style.transform = "translateY(102%)";
    el.style.visibility = "visible";
  });

  // Handle scroll events
  let isMiniNavbarVisible = false;
  
  const handleScroll = () => {
    if (window.scrollY > 500 && !isMiniNavbarVisible) {
      // Show mini navbar
      isMiniNavbarVisible = true;
      const btnElements = document.querySelectorAll(".navbar_mini_btn");
      const containElements = document.querySelectorAll(".navbar_mini_contain");
      
      // Animate elements in
      btnElements.forEach((el, index) => {
        setTimeout(() => {
          el.style.transition = "transform 0.875s cubic-bezier(0.16, 1, 0.35, 1)";
          el.style.transform = "translateY(0%)";
        }, index * 100);
      });
      
      containElements.forEach((el, index) => {
        setTimeout(() => {
          el.style.transition = "transform 0.875s cubic-bezier(0.16, 1, 0.35, 1)";
          el.style.transform = "translateY(0%)";
        }, (index + btnElements.length) * 100);
      });
    } else if (window.scrollY <= 500 && isMiniNavbarVisible) {
      // Hide mini navbar
      isMiniNavbarVisible = false;
      const btnElements = document.querySelectorAll(".navbar_mini_btn");
      const containElements = document.querySelectorAll(".navbar_mini_contain");
      
      // Animate elements out
      [...containElements, ...btnElements].forEach((el, index) => {
        setTimeout(() => {
          el.style.transition = "transform 0.875s cubic-bezier(0.16, 1, 0.35, 1)";
          el.style.transform = "translateY(102%)";
        }, index * 50);
      });
    }
  };

  window.addEventListener('scroll', handleScroll);
  
  // Store reference to remove event listener later if needed
  window.scrollHandler = handleScroll;
};

// Cleanup function to remove event listeners
export const cleanupScripts = () => {
  if (window.scrollHandler) {
    window.removeEventListener('scroll', window.scrollHandler);
    delete window.scrollHandler;
  }
};

export default initScripts;